import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

import { Context } from "@hermes/app-core";

@Injectable()
export class OriginCheckerService {
    constructor(
        private context: Context,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    /**
     * Compare referrer and current origin
     */
    public checkReferrerOrigin(): boolean {
        // escaping condition for non ssr to make sure document is defined
        if (!this.context.isInBrowserMode()) {
            return false;
        }
        const referrer = this.document.referrer;
        if (!referrer) {
            return false;
        }
        return new URL(referrer).origin === this.context.getCurrentOrigin();
    }
}
